<mat-toolbar  class="flex flex-row justify-between items-center gap-3 panel border-b">
  @if (showBrand) {
    <div class="font-gamer h2">
      <a routerLink="/">
        <fa-icon icon="face-grin-beam-sweat" class="mr-3"></fa-icon>
        <span>Gameface</span>
      </a>
    </div>
  }

  <div class="flex flex-row gap-6 items-center">

    <!--
    <a  mat-icon-button (click)="toggleDisplayMode()">
      <fa-icon icon="circle-half-stroke"></fa-icon>
    </a>-->

    <a mat-button href="{{ guidesUrl() }}" target="_blank" rel="noopener noreferrer">
      Guides
    </a>

    @if (!loading() && user()) {
      <div>
        <a [matMenuTriggerFor]="userMenu" class="cursor-pointer flex flex-row items-center gap-1">
          <app-avatar [user]="user()" size="xs" ></app-avatar>
          <fa-icon icon="caret-down"></fa-icon>
        </a>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="editProfile()">Edit profile</button>
          <button mat-menu-item (click)="signOut()">Sign out</button>
        </mat-menu>
      </div>
    }

    @if (!loading() && !user()) {
      <div class="flex flex-row gap-3">
        <button mat-button color='primary' (click)="signIn()">Sign In</button>
      </div>
    }

  </div>

</mat-toolbar>
